import React, { Component } from 'react';

export default function enhanceWithClickOutside(WrappedComponent) {
    const componentName = WrappedComponent.displayName || WrappedComponent.name;

    class EnhancedComponent extends Component {
        constructor(props) {
            super(props);

            this.wrapperRef = React.createRef();
            this.handleDocumentClick = this.handleDocumentClick.bind(this);
        }

        componentDidMount() {
            document.addEventListener('click', this.handleDocumentClick, true);
        }

        componentWillUnmount() {
            document.removeEventListener('click', this.handleDocumentClick, true);
        }

        handleDocumentClick(event) {
            const domNode = this.wrapperRef.current;
            const wrappedComponent = this.wrappedComponent;

            if (
                (!domNode || !domNode.contains(event.target)) &&
                wrappedComponent &&
                typeof wrappedComponent.handleClickOutside === 'function'
            ) {
                wrappedComponent.handleClickOutside(event);
            }
        }

        render() {
            return (
                <div
                    className="click-outside-wrapper"
                    ref={this.wrapperRef}
                    style={{ display: 'contents' }}
                >
                    <WrappedComponent
                        {...this.props}
                        ref={(instance) => {
                            this.wrappedComponent = instance;
                        }}
                    />
                </div>
            );
        }
    }

    EnhancedComponent.displayName = `Wrapped${componentName}`;

    return EnhancedComponent;
}
